import { render, staticRenderFns } from "./permissionSetting.vue?vue&type=template&id=19815b4a&"
import script from "./permissionSetting.vue?vue&type=script&lang=js&"
export * from "./permissionSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/common/permissionSetting.vue"
export default component.exports